import React from 'react';

import PSLIModalForm, { PSLIModalFormProps } from './PSLIModalForm';

const EditPSLIModalForm: React.FC<PSLIModalFormProps> = props => (
  <PSLIModalForm {...props} title="Edit Planned Shipment" submitButtonText="Update" />
);

export default EditPSLIModalForm;
